
import { Card, CardContent, CardMedia, CardActionArea, Typography} from "@mui/material"; // Importa los componentes necesarios de Material UI para crear una tarjeta
import { useNavigate } from "react-router-dom"; // Importa el hook 'useNavigate' para manejar la navegación entre rutas

export default function CustomCard(props){ // Define el componente funcional CustomCard que recibe props
  const navigate = useNavigate(); // Inicializa el hook de navegación para redirigir a otras rutas
  const {path, title, redirect} = props; // Desestructura las propiedades (path, title y redirect) de las props que se pasan al componente

  return (
    <Card> {/* Crea una tarjeta */}
      <CardActionArea onClick={()=>navigate(redirect)}> {/* Crea un área dentro de la tarjeta que detecta clics y redirige según el valor de "redirect" */}
        <CardMedia
          component="img" // Establece el componente de imagen
          height="140" // Define la altura de la imagen
          image={path} // Asigna la imagen que se pasa a través de 'path' como la fuente de la imagen
        />
        <CardContent> {/* Contenido dentro de la tarjeta */}
            <Typography> {/* Componente de texto para mostrar el título de la tarjeta */}
              {title} {/* Muestra el título de la tarjeta que se pasa a través de 'title' */}
            </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}


